'use client';

import { useEffect } from 'react';

export default function ClientScripts() {
  useEffect(() => {
    // 1. Script de Menu Mobile e Rolagem Suave
    const handleMenuClick = (e: MouseEvent) => {
      const toggle = document.getElementById('cgt-menu-toggle') as HTMLInputElement;
      
      // Fechar menu mobile
      const target = e.target as HTMLElement;
      const isNavAnchor = target.closest('.cgt-nav a');
      const isAnchor = target.closest('a[href^="#"]');
      const isNav = target.closest('.cgt-nav');
      const isHamburger = target.closest('.cgt-hamburger');
      const isToggle = target === toggle;
      
      if (toggle && toggle.checked) {
        if (isNavAnchor || (!isNav && !isHamburger && !isToggle)) {
          toggle.checked = false;
        }
      }

      // Rolagem suave manual para links âncora
      if (isAnchor) {
        const href = isAnchor.getAttribute('href');
        if (href && href.length > 1) {
          const targetEl = document.querySelector(href);
          if (targetEl) {
            e.preventDefault();
            targetEl.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }
    };
    window.addEventListener('click', handleMenuClick, { capture: true });

    // 2. Atualiza menu ativo no scroll
    const handleScroll = () => {
      const sections = document.querySelectorAll('section[id]');
      const navLinks = document.querySelectorAll('.cgt-nav a');
      const scrollPos = window.scrollY || document.documentElement.scrollTop;
      
      let currentId = '';
      
      sections.forEach((section) => {
        const top = (section as HTMLElement).offsetTop - 150;
        if (scrollPos >= top) {
          currentId = section.getAttribute('id') || '';
        }
      });
      
      navLinks.forEach((link) => {
        link.classList.remove('active');
        const href = link.getAttribute('href');
        
        if (currentId && href === '#' + currentId) {
          link.classList.add('active');
        } else if (!currentId && href === '/') {
          link.classList.add('active');
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    // Chama imediatamente para caso carregue a página já com âncora
    setTimeout(handleScroll, 100);

    // 3. Drag to scroll for horizontal carousels (Desktop)
    let isDragging = false;
    let startX: number;
    let scrollLeft: number;
    let activeSlider: HTMLElement | null = null;

    const handleMouseDown = (e: MouseEvent) => {
      const slider = (e.target as HTMLElement).closest('.cgt-ben-grid, .cgt-planos-grid, .cgt-eventos-grid') as HTMLElement;
      if (!slider) return;
      
      isDragging = true;
      activeSlider = slider;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      slider.style.scrollSnapType = 'none'; // smoother drag
      document.body.style.userSelect = 'none'; // previne seleção de texto
    };

    const handleMouseUp = () => {
      if(isDragging && activeSlider) {
         isDragging = false;
         activeSlider.style.scrollSnapType = '';
         activeSlider = null;
         document.body.style.userSelect = ''; // restaura seleção
      }
    };

    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging || !activeSlider) return;
      e.preventDefault(); // prevent text selection
      const x = e.pageX - activeSlider.offsetLeft;
      const walk = (x - startX) * 2; // scroll-fast
      activeSlider.scrollLeft = scrollLeft - walk;
    };

    window.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('mouseup', handleMouseUp);
    window.addEventListener('mousemove', handleMouseMove);

    // 4. Atualiza o card central (hover no mobile)
    const updateCenterCards = () => {
       const isMobile = window.innerWidth <= 992;
       const grids = document.querySelectorAll('.cgt-planos-grid, .cgt-eventos-grid, .cgt-ben-grid');
       grids.forEach((grid) => {
          if (!isMobile) {
              Array.from(grid.children).forEach((c) => { c.classList.remove('active'); });
              return;
          }
          const gridRect = grid.getBoundingClientRect();
          const gridCenter = gridRect.left + (grid as HTMLElement).offsetWidth / 2;
          let closestCard: Element | null = null;
          let minDistance = Infinity;
          const children = grid.children;
          for (let i = 0; i < children.length; i++) {
             const child = children[i];
             const rect = child.getBoundingClientRect();
             const childCenter = rect.left + rect.width / 2;
             const distance = Math.abs(gridCenter - childCenter);
             if (distance < minDistance) {
                minDistance = distance;
                closestCard = child;
             }
             child.classList.remove('active');
          }
          if (closestCard) {
             closestCard.classList.add('active');
          }
       });
    };
    
    const allGrids = document.querySelectorAll('.cgt-planos-grid, .cgt-eventos-grid, .cgt-ben-grid');
    allGrids.forEach((grid) => {
       grid.addEventListener('scroll', updateCenterCards);
       grid.addEventListener('touchstart', updateCenterCards, { passive: true });
    });
    window.addEventListener('resize', updateCenterCards);
    
    // Executa a função imediatamente para marcar o card central na carga inicial da página
    updateCenterCards();

    // 5. Scroll suave ao topo ao clicar em INÍCIO (ou logo) quando já está na home
    const linksInicio = document.querySelectorAll('a[href="/"]');
    const handleInicioClick = (e: Event) => {
      if (window.location.pathname === '/') {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        // Desativa o scroll guard que bloqueia scrollTo(0) nos primeiros 5s
        const w = window as any;
        if (typeof w.__disableScrollGuard === 'function') {
          w.__disableScrollGuard();
        }

        // Garante a rolagem no iOS e fallback caso o primeiro clique falhe
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => {
          if (window.scrollY > 10) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }, 100);
        
        window.history.replaceState(null, '', '/');
      }
    };
    linksInicio.forEach(link => {
      link.addEventListener('click', handleInicioClick, { capture: true });
    });

    // Cleanup na desmontagem
    return () => {
      window.removeEventListener('click', handleMenuClick, { capture: true });
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('resize', updateCenterCards);
      allGrids.forEach((grid) => {
         grid.removeEventListener('scroll', updateCenterCards);
         grid.removeEventListener('touchstart', updateCenterCards);
      });
      linksInicio.forEach(link => {
        link.removeEventListener('click', handleInicioClick, { capture: true });
      });
    };
  }, []);

  return null;
}
